import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modaloption-modal-content min-h-0 p-0 p-4 p-2 p-4" }
const _hoisted_2 = { class: "font-bold mb-3" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "p-dialog-footer document-event-modal-footer flex justify-content-end" }

import { onMounted } from 'vue';
import RadioButton from 'primevue/radiobutton';
import { useCalendarStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventProcessTypeModal',
  emits: ['close-confirm-modal', 'document-event'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const calendarStore = useCalendarStore();

const init = () => (calendarStore.selectedEvent.event_process_type = 'this');

onMounted(() => init());

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createVNode(_unref(RadioButton), {
          modelValue: _unref(calendarStore).selectedEvent.event_process_type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(calendarStore).selectedEvent.event_process_type) = $event)),
          "input-id": "option-this",
          name: "event_process_type",
          value: "this"
        }, null, 8, ["modelValue"]),
        _cache[4] || (_cache[4] = _createElementVNode("label", {
          class: "ml-1",
          for: "option-this"
        }, "This event", -1))
      ]),
      _createElementVNode("p", _hoisted_3, [
        _createVNode(_unref(RadioButton), {
          modelValue: _unref(calendarStore).selectedEvent.event_process_type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(calendarStore).selectedEvent.event_process_type) = $event)),
          "input-id": "option-this-futures",
          name: "event_process_type",
          value: "this_and_futures"
        }, null, 8, ["modelValue"]),
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          class: "ml-1",
          for: "option-this-futures"
        }, "This and following events", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_AppButton, {
        type: "secondary",
        text: "Cancel",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close-confirm-modal')))
      }),
      _createVNode(_component_AppButton, {
        type: "primary",
        text: "Save",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('document-event')))
      })
    ])
  ], 64))
}
}

})